import React from 'react';

const BrandList = [
    {
        image: './images/brand/brand-prisma1.svg'
    },
    {
        image: './images/brand/brand-react1.png'
    },
    {
        image: './images/brand/brand-mongodb1.png'
    },
    {
        image: './images/brand/brand-next1.png'
    },
    {
        image: './images/brand/brand-nestjs1.png'
    },
    {
        image: './images/brand/brand-laravel1.png'
    },
    {
        image: './images/brand/brand-mysql1.png'
    },
    ,
    {
        image: './images/brand/brand-postgresql.png'
    },
    ,
    {
        image: './images/brand/brand-php1.png'
    },
]

const BrandFour = ({brandStyle}) => {
    return (
        <ul className={`brand-list ${brandStyle}`}>
            {BrandList.map((data, index) => (
                <li key={index}>
                    <div className="brand-card">
                        <img src={`${data.image}`} alt="Brand" className="brand-card__img" width="120" height="60" style={{aspectRatio: "2/1"}} />
                    </div>
                </li>
            ))}
        </ul>
    )
}

export default BrandFour;
